export interface CookieConsent {
  analytics: boolean;
  timestamp: string;
}

const COOKIE_NAME = 'cookie_consent_v1';

export function getCookieConsent(): CookieConsent | null {
  if (typeof document === 'undefined') return null;
  const nameEQ = COOKIE_NAME + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      const value = decodeURIComponent(c.substring(nameEQ.length, c.length));
      try {
        return JSON.parse(value) as CookieConsent;
      } catch (e) {
        return null;
      }
    }
  }
  return null;
}

export function setCookieConsent(analytics: boolean): void {
  if (typeof document === 'undefined') return;
  const consent: CookieConsent = {
    analytics,
    timestamp: new Date().toISOString()
  };
  const serialized = encodeURIComponent(JSON.stringify(consent));
  
  // Determine domain
  const hostname = window.location.hostname;
  
  // 365 days expiration
  const days = 365;
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "; expires=" + date.toUTCString();
  
  let cookieStr = `${COOKIE_NAME}=${serialized}${expires}; path=/; SameSite=Lax`;
  if (hostname && hostname.endsWith('kontomatch.com')) {
    cookieStr += "; domain=.kontomatch.com";
  }
  
  document.cookie = cookieStr;
}
